import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/Overview/Overview'
import { CaseStudyItems } from 'components/cases/common/CaseStudy/CaseStudy'
import { CaseCTAItem } from 'components/cases/common/CaseCTA'

// ファーストビュー
export const firstViewItem = {
  breadcrumb: 'CVR20%向上 - 美容総合メディアのデザインリニューアル',
  title1: 'CVR20%向上 - 美容総合メディアのデザインリニューアル',
  introduction_text:
    '美容師募集情報や美容業界の最新ニュースを提供する総合メディア「re-quest/QJ navi」のデザインリニューアルを担当しました。このプロジェクトはCVR改善を目的とし、多角的なサイト分析を行った上で、新デザインを導き出しました。求人者と求職者双方の利便性を考慮し、サイト分析からUI/UXデザイン、フロントエンド開発まで一貫して実施しました。',
  company: '株式会社セイファート',
  tag1text: 'UX/UI改善',
  tag1src: '/cases/uxui-improvement/',
  tag2text: 'フロントエンド開発',
  tag2src: '/cases/frontend-dev/',
  industryTagText: 'IT/情報/通信',
  industryTagSrc: '/cases/telecommunications/',
  color: '#fff',
  background: 'linear-gradient(263.5deg, #FCA42A 0%, #EF267A 100%)',
  staff1: '取締役　鹿島修司さん',
  staff2: 'マネージャー　長澤涼子さん',
  image: '/images/img/cases/seyfert/top.png',
  alt: 'CVR20%向上 - 美容総合メディアのデザインリニューアル',
  imgClass: 'fv_img_adjust1',
}

// プロジェクト概要
export const overviewTitle = 'UI/UXデザインリニューアルでCVRが20％向上'
export const overviewItem: OverviewItems[] = [
  {
    text: '株式会社セイファートは1991年の創業以来「美容に携わるひとたちとともに、世の中に新しい価値を創造する」をテーマに掲げ、サロンサポート事業(広告求人サービス、紹介・派遣サービス、教育サービス等)を提供し続けている企業です。',
  },
  {
    text: '同社が提供するサービスの一つが、美容師求人情報に加え、美容業界の最新ニュースを提供する総合メディア「re-quest/QJ navi」。約5年ぶりとなるデザインリニューアルをアイスリーデザインが担当いたしました。',
  },
  {
    text: '求められたのは、CVRの改善を目的としたデザインのリニューアル。その課題に対して、アイスリーデザインは多角的なアプローチによるサイト分析を経て、求人／求職者それぞれの利便性、そしてCVR向上を考慮した新デザインを導き出しました。',
  },
  {
    text: '本プロジェクトの概要とその所感等を、株式会社セイファートの常務取締役 第1営業本部 本部長鹿島修司さん、サロンコミュニケーション事業部 営業企画セクション マネージャー長澤涼子さんに伺います。',
    nonMargin: true,
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: 'CVRの改善',
        text: '長期間更新されていないサイトデザインにより、コンバージョン率が最適化されていなかった。',
      },
      {
        title: 'ユーザー体験の現代化',
        text: '美容業界向けの求人サイトとして、デザインとユーザビリティを最新のトレンドに合わせる必要があった。',
      },
      {
        title: '再学習の必要性低減',
        text: '既存のユーザーが新しいサイトデザインにスムーズに適応できるように、直感的なUI/UXを提供すること。',
      },
    ],
    solutions: [
      {
        title: 'サイト分析からのデザインリニューアル',
        text: '定量分析、ヒューリスティック分析、ユーザビリティテストを実施し、具体的な問題点を特定し、それを改善するためのデザインリニューアルを実施。',
      },
      {
        title: 'CVR向上のための導線設計',
        text: '会員登録と求人への応募プロセスの最適化を行い、サイトのCVRを向上させるための導線を設計。',
      },
      {
        title: 'リニューアル後のユーザー支援',
        text: ' 既存ユーザーが新デザインに再学習することなく使えるように、直感的でわかりやすいインターフェースを実装。',
      },
    ],
  },
]

// CTA
export const caseCTAItem: CaseCTAItem = {
  title: 'その"なんとなく"のリニューアル、CVRは上がりましたか？',
  description:
    '定量分析・ヒューリスティック分析・ユーザビリティテストを組み合わせ、感覚ではなく根拠からデザインリニューアルの方向性を導き出します。まずは、現在の課題やお悩みをお聞かせください。',
}

// 関連事例
export const caseStudyItem: CaseStudyItems = [
  {
    projectName: '【技術系災害ボランティア体験】家屋再生〜水害編〜',
    client: '公益財団法人日本財団ボランティアセンター様',
    src: '/images/img/case/img_case_volunteer-ex.png',
    alt: '公益財団法人日本財団ボランティアセンター様',
    href: '#',
    tags: [{ name: 'XR/メタバース導入', url: 'xr' }],
  },
  {
    projectName: 'PEACH JOHN',
    client: '株式会社ピーチ・ジョン様',
    src: '/images/img/case/img_peachjohn.png',
    alt: '株式会社ピーチ・ジョン様',
    href: '#',
    tags: [
      { name: 'UI/UXデザイン', url: 'uiux' },
      { name: 'アプリケーション開発', url: 'application-development' },
      { name: '小売', url: 'service' },
    ],
  },
  {
    projectName: 'セブンネットショッピング「推し活倶楽部」',
    client: '株式会社セブンネットショッピング様',
    src: '/images/img/case/img_sevennet.png',
    alt: '株式会社セブンネットショッピング様',
    href: '#',
    tags: [
      { name: 'UI/UXデザイン', url: 'uiux' },
      { name: 'アーキテクチャ設計サービス', url: 'architecture-design' },
      { name: '小売', url: 'service' },
    ],
  },
]
